import React, { useEffect, useState } from 'react';
import { database } from '../../../utils/firebase';
import ReactExport from "react-export-excel";
import SavedMembers from './SavedMembers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



const MemActPopUp = ({ eventID, eventName}) => {
    const [userInfo, setUserInfo] = useState([])
    const [offset, setOffset] = useState(10)
    const [noOfPages, setNoOfPages] = useState('')
    const [pageArray, setPageArray] = useState([])
    const [noOfData, setNoOfData] = useState('')
    const [loadedData, setLoadedData] = useState([])
    const [activePage, setActivePage] = useState(1)
    const [pageState, setPageState] = useState('')
    const [metaData, setMetaData] = useState([])
    const [centers, setCenters] = useState([])
    const [getData, setGetData] = useState(false)


    const numArr = (num) => {
        const arr = []
        for (let i = 1; i <= num ; i++) {
          arr.push(i)
        }
        return arr
      }

    useEffect(() => {
        if(userInfo.length > 0) {
            setGetData(false)
            let bb = []
            userInfo.forEach(el => {
                bb.push({
                    name: el.name,
                    phone: el.phone,
                    email: el.email,
                    noOfView: el.noOfViewers,
                    prefLang: el.preferredLanguage,
                    country: el.country,
                    ft: el.AttendanceReport? el.AttendanceReport.userDetails.reduce((total, no) => 
                        {return total += no.firstTimer}, 0) : 0,
                    nc: el.AttendanceReport? el.AttendanceReport.userDetails.reduce((total, no) => 
                        {return total += no.newConvert}, 0) : 0,
                    m: el.AttendanceReport? el.AttendanceReport.userDetails.reduce((total, no) => 
                        {return total += no.member}, 0) : 0,
                    logIn: new Date(el.loggedInAt).toLocaleString(),
                    logOut: el.loggedOut? new Date(el.loggedOut).toLocaleString() : ''
                })
            })

            setCenters(bb)
        } else {
            setGetData(true)
        }
        
    }, [userInfo])

    useEffect(() => {
        if(userInfo) {
            const mData = [
                {
                    name: eventName,
                    total: userInfo.reduce((a, b) => a + b.noOfViewers, 0),
                    ft: userInfo.reduce((total, no) => {
                        return total += no.AttendanceReport? no.AttendanceReport.userDetails.reduce((total, no) => {
                            return total += no.firstTimer
                            }, 0) : 0
                        }, 0),
                    nc: userInfo.reduce((total, no) => {
                        return total += no.AttendanceReport? no.AttendanceReport.userDetails.reduce((total, no) => {
                            return total += no.newConvert
                            }, 0) : 0
                        }, 0),
                    m: userInfo.reduce((total, no) => {
                        return total += no.AttendanceReport? no.AttendanceReport.userDetails.reduce((total, no) => {
                            return total += no.member
                            }, 0) : 0
                        }, 0) 

                },
            ]
            

            setMetaData(mData)
        }
        
    }, [eventName,  userInfo])

    useEffect(() => {
        setNoOfPages(Math.ceil((userInfo.length)/10))
        setNoOfData(userInfo.length)
        setOffset(10 * activePage)
        setLoadedData(userInfo.slice((offset - 10), offset))
        setPageArray(numArr(noOfPages))
        console.log(userInfo)
    }, [activePage, userInfo, noOfData, noOfPages, offset, eventID])

    useEffect(() => {
        if(pageArray.length > 0) {
            document.querySelectorAll('.box2').forEach(el => {
                el.classList.remove('active')
            })
            if(document.querySelector(`.paged${activePage}`) === null) {   
                setActivePage(pageState - 1)
            } else {   
                return document.querySelector(`.paged${activePage}`).classList.add('active')
            }   
        }
        
    }, [activePage, userInfo, pageArray, pageArray.length, pageState, ])

    useEffect(() => {
        if(eventID) {
            const eventRef = database.ref('Events').child(eventID).child('Users')
            eventRef.on('value', (el) => {
                let eData = []
                for (let id in el.val()) {
                    eData.unshift({id, ...el.val()[id]})
                }
                setUserInfo(eData)
            })
        }
    }, [eventID])
    

    const handleCloseMemActPopUp = () => {
        document.querySelector(`.pop${eventID}`).classList.add('hide')
        document.querySelector('.admin-background').classList.add('hide')
    }

    const handleExport = () => {
        function eventFire(el, etype){
            if (el.fireEvent) {
              el.fireEvent('on' + etype);
            } else {
              var evObj = document.createEvent('Events');
              evObj.initEvent(etype, true, false);
              el.dispatchEvent(evObj);
            }
          }

          const parent = document.querySelector(`.pop${eventID}`)
          const targetBtn = parent.querySelectorAll('span')[parent.querySelectorAll('span').length - 1]
          eventFire(targetBtn, 'click');
        console.log(parent.querySelectorAll('span')[parent.querySelectorAll('span').length - 1])
        
    }

    const handleDetailedReport = (id) => {
        document.querySelector(`.sav${id}`).classList.remove('hide')
        document.querySelector(`.vc${eventID} `).classList.remove('hide')
        setTimeout(() => {
            let elmnt = document.querySelector(".content-view");
            let y = elmnt.scrollHeight;
            document.querySelector('.admin-background').style.height = `${y + 110}px`
        }, 700);
        
    }

    return (
        // Dont use span tag here if at all you can use span1 or span2 never span
        <div className={`mem-act-pop-up pop${eventID} lang-form-container hide `}>  
            <div className={`pop-background hide vc${eventID}`} id='pop-bg'> cxcx</div>
            <div className="top">
                <h3>Members activity during - "{eventName}"</h3>
                <button disabled={getData} onClick={handleExport}>Export Report</button>
            </div>

            <div className="form-close" onClick={handleCloseMemActPopUp}>
                <i class="fas fa-times"></i>
            </div>
            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="m-email dd">Email</div>
                    <div className="m-noOfView dd">No of viewers watching with you</div>
                    <div className="m-p-lang dd">Preferred Language</div>
                    <div className="m-p-country dd">Country</div>
                    <div className="m-p-m dd">FT</div>
                    <div className="m-p-m dd">NC</div>
                    <div className="m-p-m dd">M</div>
                    <div className="m-log dd">Logged in at</div>
                    <div className="m-action dd">Action</div>
                    
                </div>

            
                {loadedData.map((el, i) => {
                    return (
                        <div className="table details">
                            <SavedMembers eventID={eventID} userID={el.id} />
                            {/* <Alert message={alertMessage} eventId={el.id} action={setLanguageAlert} /> */}
                            <div className="num dd">{i + 1 + (offset -10)}</div>
                            <div className="m-email dd">{el.email}</div>
                            <div className="m-noOfView dd">{el.noOfViewers}</div>
                            <div className="m-p-lang dd">{el.preferredLanguage}</div>
                            <div className="m-p-country dd">{el.country}</div>
                            <div className="m-p-m dd">{ el.AttendanceReport? 
                                el.AttendanceReport.userDetails.reduce((total, no) => {
                                    return total += no.firstTimer
                                }, 0)
                                
                                
                                : '0'}</div>
                            <div className="m-p-m dd">
                                { el.AttendanceReport? 
                                    el.AttendanceReport.userDetails.reduce((total, no) => {
                                        return total += no.newConvert
                                    }, 0)
                                    
                                    
                                    : '0'}
                            </div>
                            <div className="m-p-m dd">
                                { el.AttendanceReport? 
                                        el.AttendanceReport.userDetails.reduce((total, no) => {
                                            return total += no.member
                                        }, 0)
                                        
                                        
                                        : '0'}
                            </div>
                            <div className="m-log dd">{new Date(el.loggedInAt).toLocaleString()}</div>
                            <div className="m-action dd">
                                <button onClick={() => handleDetailedReport(el.id)}>Detailed Server Report</button>
                            </div>
                        </div>
                    )
                })}
                
                {userInfo.length > 0? 
                    <div className="table total details">
                        {/* <Alert message={alertMessage} eventId={el.id} action={setLanguageAlert} /> */}
                        <div className="num dd"></div>
                        <div className="m-email dd">Total</div>
                        <div className="m-noOfView dd">{userInfo.reduce((a, b) => a + b.noOfViewers, 0)}</div>
                        <div className="m-p-lang dd"></div>
                        <div className="m-p-country dd"></div>
                        <div className="m-p-m dd">
                            {
                                userInfo.reduce((total, no) => {
                                    return total += no.AttendanceReport? no.AttendanceReport.userDetails.reduce((total, no) => {
                                        return total += no.firstTimer
                                    }, 0) : 0
                                }, 0)               
                            }
                        </div>
                        <div className="m-p-m dd">
                            {
                                userInfo.reduce((total, no) => {
                                    return total += no.AttendanceReport? no.AttendanceReport.userDetails.reduce((total, no) => {
                                        return total += no.newConvert
                                    }, 0) : 0
                                }, 0)               
                            }
                        </div>
                        <div className="m-p-m dd">
                            {
                                userInfo.reduce((total, no) => {
                                    return total += no.AttendanceReport? no.AttendanceReport.userDetails.reduce((total, no) => {
                                        return total += no.member
                                    }, 0) : 0
                                }, 0)               
                            }
                        </div>
                        <div className="m-log dd"></div>
                        <div className="m-action dd"></div>
                    </div>
                
                 : ''
                }

            </div>
                


            {loadedData.length > 0? 
                <div className='pagination'>
                    <div className="page-box box2" onClick={() => {
                        if(activePage > 1) {
                            setActivePage(prev=> prev - 1)
                        } 
                        }}>
                        <i class="fas fa-angle-left"></i>
                    </div>

                    {pageArray.map(el => {
                        return (
                        <div className={`page-box box2 paged${el}`} key={el} onClick={() => setActivePage(el)}>
                            {el}
                        </div>
                        )
                    })}

                    <div className="page-box box2" onClick={() => {
                        if(activePage < noOfPages) {
                            setActivePage(prev=> prev + 1)
                        } 
                        }}>
                        <i class="fas fa-angle-right"></i>
                    </div>
                </div> : 
                ''
            }

            <div className="hidden">
                <ExcelFile>
                    <ExcelSheet data={centers} name={`Centers Watching`}>
                        <ExcelColumn label="Name" value="name" />
                        <ExcelColumn label="Phone" value="phone"/>
                        <ExcelColumn label="Email" value="email"/>
                        <ExcelColumn label="No of viewers watching with you" value="noOfView"/>
                        <ExcelColumn label="Preferred Language" value="prefLang"/>
                        <ExcelColumn label="Country" value="country"/>
                        <ExcelColumn label="First Timers" value="ft"/>
                        <ExcelColumn label="New Convert" value="nc"/>
                        <ExcelColumn label="Members" value="m"/>
                        <ExcelColumn label="Logged In Time" value='logIn'/>
                        <ExcelColumn label="Logged Out Time" value='logOut'/>
                    </ExcelSheet>
                    <ExcelSheet data={metaData} name="Total">
                        <ExcelColumn label="Event" value='name'/>
                        <ExcelColumn label="Total No of Viewers" value="total"/>
                        <ExcelColumn label="Total No of First Timers" value="ft"/>
                        <ExcelColumn label="Total No of New Converts" value="nc"/>
                        <ExcelColumn label="Total No of Members" value="m"/>
                    </ExcelSheet>
                </ExcelFile>
            </div>

          
            
        </div>

    )
}


export default MemActPopUp